



















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Button } from 'element-ui';
import NavBar from '@/components/layout/NavBar.vue';
import Others from '@/components/settings/Others.vue';
import Password from '@/components/settings/Password.vue';
import UserProfile from '@/components/settings/UserDetail.vue';

// types
import { OperatorInput, OperatorFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    NavBar,
    Others,
    Password,
    UserProfile,
    'el-button': Button
  }
})
export default class Profile extends Vue {
  get profile() {
    return this.$store.state.User.profile;
  }

  logout(): void {
    this.$store.dispatch('User/logout')
      .then(() => {
        if (this.$heap) {
          this.$heap.resetIdentity();
        }
        this.$router.push({ name: 'login' });
      });
  }
}
